// components/host-control-logic.js: M3-12 pure gating for host
// controls. Shared with TeamColumns.jsx so node:test can
// cover the truth table directly.

/**
 * Can the local user kick this occupant? Only hosts can kick, only
 * non-hosts can be kicked, and you can't kick yourself.
 *
 * @param {{ is_host:boolean, is_you:boolean }} occupant
 * @param {boolean} viewerIsHost
 * @returns {boolean}
 */
export function canKickOccupant(occupant, viewerIsHost) {
  if (!viewerIsHost) return false;
  if (occupant.is_you) return false;
  if (occupant.is_host) return false;
  return true;
}
